<div class="file-upload-modal-overlay" (click)="onClose()">
  <div class="file-upload-modal" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="modal-header">
      <div class="header-content">
        <h2 class="modal-title">
          <span class="icon">📁</span>
          File Upload
        </h2>
        <p class="modal-subtitle">
          Upload files for {{ partIndex !== undefined ? 'Part ' + (partIndex + 1) : 'your quote' }}
        </p>
      </div>
      <button class="close-button" (click)="onClose()" [disabled]="isUploading">
        <span class="icon">×</span>
      </button>
    </div>

    <!-- Modal Body -->
    <div class="modal-body">
      <!-- Tab Navigation -->
      <div class="tab-navigation">
        <button 
          class="tab-button" 
          [class.active]="currentTab === 'upload'"
          (click)="onTabChange('upload')">
          <span class="icon">📤</span>
          Upload Files
          <span class="badge" *ngIf="selectedFiles.length > 0">{{ selectedFiles.length }}</span>
        </button>
        <button 
          class="tab-button" 
          [class.active]="currentTab === 'uploaded'"
          (click)="onTabChange('uploaded')">
          <span class="icon">📋</span>
          Uploaded Files
          <span class="badge" *ngIf="uploadedFiles.length > 0">{{ uploadedFiles.length }}</span>
        </button>
      </div>

      <!-- Upload Tab -->
      <div class="tab-content" *ngIf="currentTab === 'upload'">
        <!-- Drag & Drop Zone -->
        <div 
          class="drop-zone" 
          [class.drag-over]="isDragOver"
          [class.has-files]="hasSelectedFiles"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)">
          
          <div class="drop-zone-content" *ngIf="!hasSelectedFiles">
            <div class="drop-icon">📁</div>
            <h3>Drag & Drop Files Here</h3>
            <p>or click to browse files</p>
            <input 
              #fileInput
              type="file" 
              multiple 
              accept=".pdf,.jpg,.jpeg,.png,.gif,.bmp,.tif,.tiff,.dwg,.dxf,.step,.stp,.sldprt,.slddrw,.igs,.iges,.ipt,.x_t,.stl,.obj,.3mf,.doc,.docx,.xls,.xlsx,.txt,.zip"
              (change)="onFileSelect($event)"
              class="file-input">
            <button class="browse-button" (click)="fileInput.click()">
              Browse Files
            </button>
          </div>

          <!-- Selected Files List -->
          <div class="selected-files" *ngIf="hasSelectedFiles">
            <div class="files-header">
              <h4>Selected Files ({{ selectedFiles.length }})</h4>
              <div class="total-size">Total: {{ formattedTotalSize }}</div>
            </div>
            
            <div class="files-list">
              <div 
                class="file-item" 
                *ngFor="let file of selectedFiles; trackBy: trackByFileName">
                <div class="file-info">
                  <span class="file-icon">{{ getFileIcon(file.type) }}</span>
                  <div class="file-details">
                    <div class="file-name">{{ file.name }}</div>
                    <div class="file-meta">
                      {{ getFileTypeLabel(file.type) }} • {{ formatFileSize(file.size) }}
                    </div>
                  </div>
                </div>
                <button 
                  class="remove-button" 
                  (click)="removeSelectedFile(file.name)"
                  [disabled]="isUploading">
                  <span class="icon">×</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Validation Errors -->
        <div class="validation-errors" *ngIf="hasErrors">
          <div class="error-section" *ngIf="getObjectKeys(validationErrors).length > 0">
            <h4 class="error-title">Validation Errors</h4>
            <div class="error-list">
              <div 
                class="error-item" 
                *ngFor="let fileName of getObjectKeys(validationErrors)">
                <span class="error-icon">⚠️</span>
                <span class="error-file">{{ fileName }}</span>
                <span class="error-message">{{ validationErrors[fileName].join(', ') }}</span>
              </div>
            </div>
          </div>

          <div class="error-section" *ngIf="getObjectKeys(uploadErrors).length > 0">
            <h4 class="error-title">Upload Errors</h4>
            <div class="error-list">
              <div 
                class="error-item" 
                *ngFor="let fileName of getObjectKeys(uploadErrors)">
                <span class="error-icon">❌</span>
                <span class="error-file">{{ fileName }}</span>
                <span class="error-message">{{ uploadErrors[fileName] }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Upload Progress -->
        <div class="upload-progress" *ngIf="isUploading">
          <div class="progress-header">
            <h4>Uploading Files...</h4>
            <span class="progress-percentage">{{ uploadProgress | number:'1.0-0' }}%</span>
          </div>
          <div class="progress-bar">
            <div class="progress-fill" [style.width.%]="uploadProgress"></div>
          </div>
          <p class="progress-text">Please wait while your files are being uploaded...</p>
        </div>

        <!-- Help Section -->
        <div class="help-section">
          <button class="help-toggle" (click)="toggleHelp()">
            <span class="icon">{{ showHelp ? '−' : '+' }}</span>
            File Upload Help
          </button>
          
          <div class="help-content" *ngIf="showHelp">
            <div class="help-grid">
              <div class="help-item">
                <h5>Supported File Types</h5>
                <ul>
                  <li><strong>2D Drawing Files:</strong> PDF (.pdf), Images (.jpg, .jpeg, .png, .gif, .bmp, .tif, .tiff)</li>
                  <li><strong>CAD Files:</strong> AutoCAD (.dwg, .dxf), SolidWorks (.sldprt, .slddrw), STEP (.step, .stp), IGES (.igs, .iges), Inventor (.ipt), Parasolid (.x_t), STL (.stl), OBJ (.obj), 3MF (.3mf)</li>
                  <li><strong>Office Files:</strong> Word (.doc, .docx), Excel (.xls, .xlsx), Text (.txt)</li>
                  <li><strong>Compressed Files:</strong> ZIP (.zip)</li>
                </ul>
              </div>
              <div class="help-item">
                <h5>File Size Limits</h5>
                <ul>
                  <li>Maximum file size: 10MB per file</li>
                  <li>Multiple files can be uploaded at once</li>
                  <li>Drag and drop or click to browse</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Uploaded Files Tab -->
      <div class="tab-content" *ngIf="currentTab === 'uploaded'">
        <div class="uploaded-files" *ngIf="hasUploadedFiles; else noUploadedFiles">
          <div class="files-header">
            <h4>Uploaded Files ({{ uploadedFiles.length }})</h4>
          </div>
          
          <div class="files-list">
            <div 
              class="file-item uploaded" 
              *ngFor="let file of uploadedFiles; trackBy: trackByFileName">
              <div class="file-info">
                <span class="file-icon">{{ getFileIcon(file.fileType) }}</span>
                <div class="file-details">
                  <div class="file-name">{{ file.fileName }}</div>
                  <div class="file-meta">
                    {{ getFileTypeLabel(file.fileType) }} • Uploaded
                  </div>
                </div>
              </div>
              <div class="file-actions">
                <button class="action-button" (click)="downloadFile(file)">
                  <span class="icon">⬇️</span>
                </button>
                <button class="action-button remove" (click)="removeUploadedFile(file.fileName)">
                  <span class="icon">🗑️</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <ng-template #noUploadedFiles>
          <div class="empty-state">
            <div class="empty-icon">📁</div>
            <h4>No Files Uploaded</h4>
            <p>Upload files in the "Upload Files" tab to see them here.</p>
          </div>
        </ng-template>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="modal-footer">
      <div class="footer-actions">
        <button 
          class="btn btn-secondary" 
          (click)="clearAllFiles()"
          [disabled]="isUploading || (!hasSelectedFiles && !hasUploadedFiles)">
          Clear All
        </button>
        
        <div class="primary-actions">
          <button 
            class="btn btn-secondary" 
            (click)="onClose()"
            [disabled]="isUploading">
            Cancel
          </button>
          
          <button 
            class="btn btn-primary" 
            (click)="uploadFiles()"
            [disabled]="!canUpload"
            *ngIf="currentTab === 'upload'">
            <span class="icon" *ngIf="!isUploading">📤</span>
            <span class="icon loading" *ngIf="isUploading">⏳</span>
            {{ isUploading ? 'Uploading...' : 'Upload Files' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div> 